import { useLocation } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { GoldButton, Reveal, SectionHeading } from "../components/ui-kit";
import { SERVICES } from "../data/content";

export function PageHeader({ overline, title, subtitle, image }) {
  return (
    <section className="relative pt-40 pb-20 overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/85 to-background" />
        </div>
      )}
      <div className="relative z-10 max-w-5xl mx-auto px-5 sm:px-8">
        {overline && <p className="text-gold uppercase tracking-[0.3em] text-xs mb-5">{overline}</p>}
        <h1 className="font-serif text-5xl sm:text-6xl leading-tight max-w-3xl">{title}</h1>
        {subtitle && <p className="mt-6 text-lg text-foreground/80 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export default function ServiceDetail() {
  const { pathname } = useLocation();
  const slug = pathname.replace("/", "");
  const s = SERVICES.find((x) => x.slug === slug) || SERVICES[0];
  return (
    <div data-testid={`service-page-${s.slug}`}>
      <PageHeader overline="Prestation KMR Event" title={s.title} subtitle={s.tagline} image={s.image} />
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <div className="space-y-5">
              {s.long.map((p) => <p key={p} className="text-foreground/80 leading-relaxed text-lg">{p}</p>)}
              <div className="glass rounded-xl p-5 mt-4 border-gold/20">
                <p className="text-sm text-muted-foreground">Chaque devis dépend du type d'événement, de la date, de la durée, du lieu, du nombre de participants, du matériel et des services choisis.</p>
              </div>
              <GoldButton to="/devis" className="mt-4" data-testid="service-detail-devis">Demander un devis <ArrowRight size={16} /></GoldButton>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="glass rounded-2xl p-8">
              <SectionHeading title="Ce qui est inclus" className="max-w-full" />
              <ul className="mt-6 space-y-3">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-foreground/85"><Check size={18} className="text-gold shrink-0 mt-1" /> {p}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
